import requestMaker from 'lib';

export const submitRating = ratingPayload => {
  const baseQuery = `/proxy/prv/yk/sr`;
  const { ratingSystemId } = ratingPayload;
  const params = { ratingSystemId };
  const payload = { ...ratingPayload };
  return requestMaker(baseQuery, { params, payload });
};
